import React, { type FC } from 'react'
import type { SxProps, Theme } from '@mui/material'

import { Translation } from '../../../domain'

import { Button, UploadIcon } from '../common'
import { FormattedTranslation } from '../Internationalization'

const buttonStyle: SxProps<Theme> = { ml: 2 }

export const UploadServiceButton: FC<Readonly<{ onClick: VoidFunction, disabled: boolean }>> = (props) => (
    <Button data-testid="add-service" sx={buttonStyle} variant="primary" size="large" startIcon={<UploadIcon />} {...props}>
        <FormattedTranslation id={Translation.UPLOAD_SERVICE} />
    </Button>
)
